import * as React from "react";

import './textSizeAcknowledgement.scss';

import {cs}             from "@Common/react/chain-services";
import {Checkbox}       from "@Common/ui-components/heavy/common/design2/checkbox/checkbox";


export const TextSizeAcknowledgement = ({agreed, fontSizeWarn, errors})=> cs(
    ({}) => (
        <div className="text-size-acknowledgement-w7t">
            <div className="checkbox-container">
                <div className="agree"
                    onClick={() => agreed.onChange(!agreed.value)}
                >
                    {Checkbox({checked: agreed.value, xdQaName: "Terms and Acknowledgement"})}
                </div>
            </div>
            <div className="acknowledgement-text-container">
                <label xd-qa-type="label" xd-qa-name="Acknowledgement">
                    The text in your comment area(s) will be smaller than {fontSizeWarn} point type.  It is BELOW the recommended type size for optimal printing and viewing results.Please review the comments area(s) and the actual text size below:
                    {errors && errors?.resizing_info?.map(name => (
                        <p key={name}>{name}</p>
                    ))}
                    To increase your text size,  you must remove characters and/or blank spaces in the comments area(s).  Hard returns also decrease text size. Click on Edit Proof to make any changes and proof again.To disregard this warning, select the check box to proceed with your order as is.
                </label>
            </div>
        </div>
    )
);